import { AnimatedOutlet } from "./animated-outlet";
import { RouteTransitionProvider } from "@/contexts/route-transition-context";
import { WidgetHeader } from "./widget-header/widget-header";
import { cn } from "@/lib/utils";
import { useWidgetVariant } from "@/contexts/widget-variant";

export const Layout = () => {
  const variant = useWidgetVariant();
  const showHeader = variant !== "in-game";

  return (
    <RouteTransitionProvider>
      <div
        className={cn(
          "flex h-full w-full flex-col overflow-hidden bg-background md:border md:border-border/40",
          // In-game the panel is inset on every side (see WidgetContainer), so it is a fully
          // rounded card at every width; the on-site header variant already is.
          "rounded-2xl"
        )}
      >
        {showHeader && <WidgetHeader />}
        <main className="relative min-h-0 w-full flex-1 overflow-x-hidden overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch]">
          <AnimatedOutlet />
        </main>
      </div>
    </RouteTransitionProvider>
  );
};
